import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';

import { Status } from "../../Config/Status.js";
import { Options } from "../../Config/Options.js";

import Introduction from "./Introduction.js";


const Home = {
  init() {
    gsap.registerPlugin(ScrollTrigger);
    Introduction.phase01();
    Introduction.phase02();
    Introduction.phase03();
  },
  load() {
  },
  resize() {
  },
  resizeW() {
  },
  scroll() {
  },
  orientation() {
  }
}


export default Home;